<template>
  <div>
    <div class="mb-10 bg-white border rounded border-ricoma-gray-300">
      <div class="py-8">
        <VideoForm
          :initialValues="video"
          :errors="errors"
          @set="handleSetField"
          :showIntro="false"
        />
      </div>
    </div>
    <button type="button" class="py-4 button max-w-none" @click="handleSubmit(handleSaveVideo)()">
      Save
    </button>
  </div>
</template>

<script>
import VideoForm from '@/components/admin/VideoForm';

import { formMixin, videosEditMixin } from '@/mixins';

export default {
  name: 'AdminPostTrainingVideosEdit',
  components: {
    VideoForm,
  },
  mixins: [
    formMixin({ title: '', summary: '', order: '', embed_code: '' }),
    videosEditMixin('post-training-videos'),
  ],
  watch: {
    async language({ code }) {
      this.video = await this.fetchVideo(this.$http, this.$route.params.id, code);
    },
  },
  methods: {
    async handleSaveVideo(data) {
      const id = this.video.id;
      const { code: lang_code } = this.language;

      const requestData = {
        ...this.video,
        ...data,
        lang_code,
      };

      const formData = new FormData();
      Object.keys(requestData).forEach(key => formData.append(key, requestData[key]));

      await this.$http.post(`/admin/post-training-videos/${id}`, formData);

      this.handleResetFields();

      // go back to the view mode for this video series
      this.$router.push(`/admin/post-training-videos/view/${this.video.group_id}`);
    },
  },
};
</script>
